import { create } from "zustand"
import type { ConfirmedRankingState, ConfirmedRankingData } from "./types"
import { CONFIRMED_RANKING_STORAGE_KEY } from "./types"

function loadFromStorage(): Record<string, ConfirmedRankingData> {
    if (typeof localStorage === "undefined") return {}
    try {
        const raw = localStorage.getItem(CONFIRMED_RANKING_STORAGE_KEY)
        if (!raw) return {}
        const parsed = JSON.parse(raw) as Record<string, ConfirmedRankingData>
        return typeof parsed === "object" && parsed !== null ? parsed : {}
    } catch {
        return {}
    }
}

function saveToStorage(data: Record<string, ConfirmedRankingData>) {
    if (typeof localStorage === "undefined") return
    try {
        localStorage.setItem(CONFIRMED_RANKING_STORAGE_KEY, JSON.stringify(data))
    } catch {
        // ignore
    }
}

const useConfirmedRankingStore = create<ConfirmedRankingState>((set, get) => ({
    confirmedRankingByMarket: loadFromStorage(),

    setConfirmedRanking: (market, data) => {
        set((state) => {
            const next = { ...state.confirmedRankingByMarket, [market]: data }
            saveToStorage(next)
            return { confirmedRankingByMarket: next }
        })
    },

    mergeConfirmedRankingsFromServer: (entries) => {
        if (!entries.length) return
        set((state) => {
            const next = { ...state.confirmedRankingByMarket }
            for (const e of entries) {
                const text = e.ranking_text?.trim()
                const cypher = e.cypher_query?.trim()
                if (text && cypher) {
                    next[e.market] = { ranking_text: text, cypher_query: cypher }
                }
            }
            saveToStorage(next)
            return { confirmedRankingByMarket: next }
        })
    },

    getConfirmedRanking: (market) => get().confirmedRankingByMarket[market],
}))

export { useConfirmedRankingStore }
